export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const toTitleCase = (text) => {
    if (!text || typeof text !== 'string') return text;
  
    const articles = ['a', 'an', 'the'];
    const conjunctions = ['and', 'or', 'but', 'nor', 'for', 'yet', 'so'];
    const prepositions = ['in', 'on', 'at', 'to', 'for', 'of', 'with', 'by', 'from', 'up', 'about', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'between', 'among', 'under', 'over', 'around', 'near', 'across', 'behind', 'beneath', 'beside', 'beyond', 'inside', 'outside', 'within', 'without'];
  
    const lowercaseWords = new Set([...articles, ...conjunctions, ...prepositions]);
  
    const normalizedText = String(text).trim().replace(/\s+/g, ' ').replace(/&/g, 'and').toLowerCase();
    const words = normalizedText.split(' ');
  
    const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  
    const processWithDelimiters = (word) => {
      const parts = word.split(/([\/-])/);
      let segmentIndex = 0;
      return parts
        .map((part, idx) => {
          if (part === '/' || part === '-') return part;
          if (!part) return part;
  
          const prevDelimiter = idx > 0 ? parts[idx - 1] : null;
          const shouldCapitalize = segmentIndex === 0 || prevDelimiter === '/';
          segmentIndex += 1;
  
          if (shouldCapitalize) {
            return capitalize(part);
          }
  
          if (prevDelimiter === '-') {
            return part.toLowerCase();
          }
  
          return part;
        })
        .join('');
    };
  
    const result = words
      .map((word, index) => {
        const isFirst = index === 0;
        const isLast = index === words.length - 1;
        const core = word.replace(/[.,!?;:]+$/g, '');
        const hasDelimiter = /[\/-]/.test(core);
        if (hasDelimiter) {
          return processWithDelimiters(core);
        }
        if (!isFirst && !isLast && lowercaseWords.has(core)) {
          return core;
        }
        return capitalize(core);
      })
      .join(' ');
  
    return result;
  };

// Ensure consistent title case for the specific category, even with &nbsp;/non‑breaking spaces
export const formatLeadingOutOfATeam = (text) => {
  if (!text || typeof text !== 'string') return text;
  const normalized = text.replace(/\u00a0|&nbsp;/gi, ' ').trim().toLowerCase();
  if (normalized === 'leading out of a team') {
    return toTitleCase(normalized);
  }
  return text;
};